import {
	type FanShopProductType,
	type FanShopProductVariant,
	type FetchFanShopProductVariantByProductVariantIdData,
	type FetchFanShopProductVariantByProductVariantIdParamsDetails,
	minutesToMs,
	type Mutate
} from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { type ProductTypeNames } from '../../models/product';
import { fanShopApi } from '../api';

export const UseProductQueryKeyBuilder = (variantId?: string) =>
	['fanShop', 'product', variantId, 'rewardPointBalance'] as const;
export type ProductVariantExtended =
	| any
	| (FanShopProductVariant & Mutate<FanShopProductType, 'name', { name: ProductTypeNames }>);

/**
 * Returns a product
 */

export const useProductQueries = (
	variantId?: string,
	options?: Omit<
		UseQueryOptions<FetchFanShopProductVariantByProductVariantIdData, unknown, ProductVariantExtended>,
		'queryFn'
	>
) => {
	return useQuery<FetchFanShopProductVariantByProductVariantIdData, unknown, ProductVariantExtended>({
		enabled: !!variantId,
		queryFn: async () =>
			(await fanShopApi).fetchFanShopProductVariantByProductVariantId({
				'details[]': [
					'productTranslations',
					'productCategoryTranslations',
					'productVariantTranslations',
					'totalUserProductPurchases',
					'productVariantImages',
					'productImages',
					'productVariant:hasCheckoutCompleted'
				] as Array<FetchFanShopProductVariantByProductVariantIdParamsDetails>,
				productVariantId: variantId || ''
			}),
		queryKey: UseProductQueryKeyBuilder(variantId),
		select: data => data.data || {},
		staleTime: minutesToMs(5),
		...options
	});
};
